(() => {
  const benefitText = 'Create a calming daily ritual in just a few minutes';

  const addBenefit = (root = document) => {
    root.querySelectorAll('[data-nz-product] .nz-benefits').forEach((list) => {
      const alreadyExists = Array.from(list.children).some(
        (item) => item.textContent.trim().toLowerCase() === benefitText.toLowerCase()
      );

      if (alreadyExists) return;

      const item = document.createElement('li');
      item.textContent = benefitText;
      list.appendChild(item);
    });
  };

  const run = () => addBenefit(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => {
    addBenefit(event.target || document);
  });
})();
